export { default as Header } from "./Header/Header";
export { default as Main } from "./Main/Main";
export { default as NewArticle } from "./NewArticle/NewArticle";
export { default as Articles } from "./Articles/Articles";
export { default as Article } from "./Article/Article";
export { default as Footer } from "./Footer/Footer";
export { default as About } from "./About/About";
export { default as SinglePageArticle } from "./SinglePageArticle/SinglePageArticle";
export { default as Edit } from "./Edit/Edit";
export { default as Delete } from "./Delete/Delete";




// WEBPACK FOOTER //
// ./src/components/index.js